









export default {
  name: 'RetryArrowIcon',
  props: {
    color: {
      type: String,
      default: '#000'
    }
  }
}
